/**
 * DayCountBadge — the total-event count on a dense calendar day cell (BON-142).
 * Shown for any day with 2+ events and, like the "+N more" link, hands off to
 * the cell's `onDayOverflowClick` rather than opening a popover.
 */
export interface DayCountBadgeProps {
  count: number;
  onClick: () => void;
}

export function DayCountBadge({ count, onClick }: DayCountBadgeProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`${count} workshops — view all`}
      style={{
        flex: '0 0 auto',
        minWidth: 16,
        height: 16,
        borderRadius: 8,
        padding: '0 4px',
        fontSize: 9.5,
        fontWeight: 700,
        lineHeight: '16px',
        textAlign: 'center',
        border: '1px solid var(--nb-border-2)',
        background: 'var(--nb-bg-2, rgba(0,0,0,.04))',
        color: 'var(--nb-subtle)',
        cursor: 'pointer',
      }}
    >
      {count}
    </button>
  );
}
